export class SearchCriteria {
  SearchTerm: string;
  Sort: string;
  Order: string;
  PageNumber: number;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/search-criteria.model.ts